/* eslint-disable import/no-anonymous-default-export */
import { UPDATE_LANGUAGE } from 'store/types';

const initialState = {
  lang: localStorage.getItem('i18nextLng') || 'en-US',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_LANGUAGE:
      return {
        ...state,
        lang: action.payload,
      };
    default:
      return state;
  }
}
